import React from 'react';
import {useTranslation} from 'react-i18next';

import {Modal, ModalActions, ModalContent, ModalHeader, showModal} from '@edna/components';

import {ModalCenterImage, SecondaryText} from 'src/components/primitives';
import {CatImage} from 'src/images';

const SuccessModal = React.memo(() => {
  const {t} = useTranslation();

  return (
    <Modal width="434px">
      <ModalHeader>{t('HelpWidget:feedbackModal.title')}</ModalHeader>
      <ModalContent>
        <SecondaryText>{t('HelpWidget:feedbackModal.description')}</SecondaryText>
        <ModalCenterImage as={CatImage} />
      </ModalContent>
      <ModalActions />
    </Modal>
  );
});

const showSuccessModal = () => showModal(() => <SuccessModal />);

export {showSuccessModal};
